import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  OnDestroy,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
} from '@angular/core';
import { PlatformService } from '@panamax/app-state';
import { ReportStoredProcedure } from '@usf/ngrx-customer-reporting';

@Component({
  selector: 'app-csv-download-card',
  templateUrl: './csv-download-card.component.html',
  styleUrls: ['./csv-download-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CsvDownloadCardComponent implements OnInit, OnChanges, OnDestroy {
  @Input() storedProcedure: ReportStoredProcedure;
  @Input() buttonLabel: string;
  @Input() disabledState: any;
  @Input() loadingState: any;
  @Output() downloadCSVReport = new EventEmitter<ReportStoredProcedure>();

  loading = false;
  showTimeMessage = false;
  disabled = false;
  private timeoutId: any = null;

  constructor(
    public platformService: PlatformService,
    private cdr: ChangeDetectorRef,
  ) {}

  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges): void {
    // Map stored procedure names to their corresponding state properties in the loadingState object
    const procedureToStateMap = {
      SP_QUERY_SALES_DETAIL_DATA: 'detailData',
      SP_QUERY_PRODUCT_DETAIL_DATA: 'productDetailData',
      SP_QUERY_INVOICE_HISTORY_DATA: 'invoiceHistoryData',
    };

    // Get the state key that corresponds to the current stored procedure
    const stateKey = procedureToStateMap[this.storedProcedure];
    if (stateKey && this.disabledState) {
      this.disabled = this.disabledState[stateKey];
    }

    if (stateKey && this.loadingState) {
      const isCurrentlyLoading = this.loadingState[stateKey];

      // Only update if the loading state has changed
      if (this.loading !== isCurrentlyLoading) {
        this.loading = isCurrentlyLoading;

        if (this.loading) {
          this.clearTimeout();

          // Set a timer to show a message if loading takes more than 10 seconds
          this.timeoutId = setTimeout(() => {
            this.showTimeMessage = true;
            this.cdr.markForCheck();
          }, 10000);
        } else {
          // Hide the time message and clear the timeout when loading is complete
          this.showTimeMessage = false;
          this.clearTimeout();
        }

        this.cdr.detectChanges();
      }
    }
  }

  private clearTimeout(): void {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
      this.timeoutId = null;
    }
  }

  ngOnDestroy(): void {
    this.clearTimeout();
  }

  emitDownload() {
    this.downloadCSVReport.emit(this.storedProcedure);
  }
}
